import { useCallback, useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { useAuth } from "src/contexts/auth-provider";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_MODIFIER_ITEM_OPTION } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { UpdateModifierItemOptionInput } from "src/interfaces/modifier.interface";
import { useModifierItemsByCategoryCorrelationId } from "./useModifierItemsByCategoryCorrelationId";

export const useUpdateModifierItemOption = () => {

  const [isUpdatingModifierItemOption, setIsUpdatingModifierItemOption] = useState(false);
  
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const { fetchModifierItemsByCategoryCorrelationId } = useModifierItemsByCategoryCorrelationId();

  const updateModifierItemOption = useCallback(async (updateModifierItemOptionInput: UpdateModifierItemOptionInput) => {
    if (!hasRestaurant?.correlationId) {
      return null;
    }

    setIsUpdatingModifierItemOption(true);
    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_MODIFIER_ITEM_OPTION,
        variables: {
          updateModifierItemOptionInput,
        },
      });

      if (data?.data?.updateModifierItemOption) {
        successToast("Modifier item option updated successfully");
        
        // Refresh all modifier items to sync data
        await fetchModifierItemsByCategoryCorrelationId();
      } else {
        throw new Error("Failed to update modifier item option");
      }
    } catch (err) {
      console.error("Error updating modifier item option:", err);
      return null;
    } finally {
      setIsUpdatingModifierItemOption(false);
    }
  }, [axBe, hasRestaurant?.correlationId, fetchModifierItemsByCategoryCorrelationId]);

  return {
    updateModifierItemOption,
    isUpdatingModifierItemOption,
  };
};
